import { render, staticRenderFns } from "./ColumnLabels.vue?vue&type=template&id=9542503e"
import script from "./ColumnLabels.vue?vue&type=script&lang=js"
export * from "./ColumnLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports